import styled, { css } from "styled-components";

interface AddMoneyInputProps {
    $hasError?: boolean;
}

export const Container = styled.div`
    display: flex;
    margin-left: 44px;
    margin-top: ${props => props.theme.spacing.xSmall};
`;

export const AddMoneyInput = styled.input<AddMoneyInputProps>`
    ${props => props.theme.typography["V2.body1.neutral.medium"]}
    background: ${props => props.theme.colors[props.theme.colorMode].background_Primary};
    border: 1.5px solid ${props => props.theme.colors[props.theme.colorMode].special_positive};
    border-radius: ${props => props.theme.cornerRadius.small};
    padding: ${props => props.theme.spacing.empty} ${props => props.theme.spacing.medium};
    width: 84px;
    height: 44px;
    outline: 0;
    margin: ${props => props.theme.spacing.empty};
    box-shadow: none;
    box-sizing: border-box;
    caret-color: ${props => props.theme.colors[props.theme.colorMode].special_positive};
    color: ${props => props.theme.colors[props.theme.colorMode].text_Highest_Emphasis};
    text-align: center;
    -webkit-appearance: none;

    ${props =>
        props.$hasError &&
        css`
            border: 1.5px solid ${props.theme.colors[props.theme.colorMode].negative};
        `}
`;

export const ButtonWrapper = styled.div`
    margin-left: ${props => props.theme.spacing.small};
    text-transform: uppercase;
    width: 100%;
`;
